// extracted by mini-css-extract-plugin
export default {"control":"schedule_control__Eda9Z","Cancel":"schedule_Cancel__ZDZt5"};